import { LocalizedMoment } from '../locale/locale.model';

export const momentUtcToLocal = (date: Date, format?: string): LocalizedMoment => {
  if (!date) {
    return { value: moment().subtract(1000, 'y'), localizationKey: 'Common.notAvailable' };
  }
  return {
    value: moment.utc(date).local(),
    localizationKey: format || 'L LT'
  };
}

export const momentLocalToUtc = (date: moment.Moment): string => {
  return moment.utc(date).toISOString();
}
